<rt-dialog-header
  [heading]="'tlc.ask_hr.form_template_create.heading' | translate"
  [subheading]="'tlc.ask_hr.form_template_create.subheading' | translate"
>
  <div
    ngProjectAs="rt-button"
    [rtTooltip]="'tlc.ask_hr.form_template_create.cant_publish_empty' | translate"
    [rtTooltipEnabled]="submitButtonDisabled()"
    [rtTooltipPosition]="'left'"
  >
    <rt-button variant="primary" [disabled]="submitButtonDisabled()" (click)="save()">
      {{
        (dialogData.template?.id
          ? 'tlc.ask_hr.form_template_create.save_changes'
          : 'tlc.ask_hr.form_template_create.publish'
        ) | translate
      }}
    </rt-button>
  </div>
</rt-dialog-header>
<rt-dialog-body layout-justify-center>
  <div class="dialog-body">
    <rt-segmented-control
      type="view-switcher"
      [segmentedButtons]="switcherButtons()"
      (segmentedButtonClicked)="onViewSwitch($event)"
      layout-align-self-center
      margin-bottom
    />
    @switch (activeView()) {
      @case ('form') {
        <ask-template-form
          [askTemplateForm]="askTemplateForm"
          [selectedMembers]="dialogData.template?.autoAssignees ?? []"
          [autoAssignmentsRequired]="!dialogData.template"
          [errors]="errors()"
          margin-bottom-medium
        />
        <dynamic-form-define
          [formState]="initialDefineFormState()"
          (formStateChanged)="onDynamicFormChanged($event)"
          (formStatusChanged)="dynamicFormStatus.set($event)"
          layout-full-width
        />
      }
      @case ('preview') {
        <rt-infobox
          iconName="info-outline"
          [isDismissible]="false"
          [hasDotDivider]="false"
          [heading]="'tlc.ask_hr.form_template_create.form_preview' | translate"
          [subheading]="'tlc.ask_hr.form_template_create.form_preview_description' | translate"
          margin-bottom-medium
        />
        <ask-template-card [askTemplate]="askTemplateValue()" margin-bottom-medium />
        @if (askTemplateForm.value.prioritySelectionEnabled) {
          <input-radio-respond
            [respondConfig]="priorityConfig"
            [respondForm]="priorityControl"
            margin-bottom-medium
          />
        }
        <dynamic-form-respond [formConfig]="respondFormConfig()" />
      }
    }
  </div>
</rt-dialog-body>
